/**
 * Client side of query understanding (spec D9/D10), Angular-free so every finder
 * page (grants now; jobs and people next) shares it. The server's `understood`
 * echo carries the MERGED filters it applied; the page replaces its rail state
 * with that echo (`FiltersFromEcho`), renders judged constraints as
 * "not yet applied" pills (`JudgedPills`), and, on the next fresh submit, drops
 * the previous query's groups before re-extracting (`StripQueryGroups`).
 */
export interface JudgedConstraint { readonly kind: string; readonly value: string; }
export interface FinderPill { readonly Key: string; readonly Label: string; readonly Value: string; }

export const JUDGED_KEY_PREFIX = 'judged:';
export const NOT_YET_APPLIED = 'not yet applied';
export const JUDGED_LABELS: Readonly<Record<string, string>> = { careerStage: 'Career stage' };

export function JudgedPills(judged: ReadonlyArray<JudgedConstraint>): FinderPill[] {
    return judged.map((j) => ({ Key: `${JUDGED_KEY_PREFIX}${j.kind}:${j.value}`, Label: JUDGED_LABELS[j.kind] ?? j.kind, Value: `${j.value} · ${NOT_YET_APPLIED}` }));
}

export function IsJudgedKey(key: string): boolean {
    return key.startsWith(JUDGED_KEY_PREFIX);
}

export function RemoveJudged(judged: ReadonlyArray<JudgedConstraint>, key: string): JudgedConstraint[] {
    return judged.filter((j) => `${JUDGED_KEY_PREFIX}${j.kind}:${j.value}` !== key);
}

export function FiltersFromEcho<TFilters extends object>(echo: { [K in keyof TFilters]?: TFilters[K] | null }, empty: TFilters): TFilters {
    const out = { ...empty };
    for (const key of Object.keys(empty) as Array<keyof TFilters>) {
        const v = echo[key];
        if (v !== null && v !== undefined) out[key] = v;
    }
    return out;
}

export function StripQueryGroups<TFilters extends object>(filters: TFilters, groupFields: Readonly<Record<string, ReadonlyArray<keyof TFilters>>>, fromQuery: ReadonlyArray<string>, empty: TFilters): TFilters {
    const out = { ...filters };
    for (const group of fromQuery) {
        for (const field of groupFields[group] ?? []) out[field] = empty[field];
    }
    if ('fromQuery' in out) (out as Record<string, unknown>)['fromQuery'] = [];
    return out;
}
